import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

const BackButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 80px;
  border: 1px solid rgba(230, 233, 239, 1);
  padding: 4px;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
`;


const BackButton =({pathName}) =>{

    const navigate = useNavigate();
    const handleBack = () => {
        if (pathName) {
            navigate({ pathname: pathName });
        } else {
            navigate(-1);
        }
    }

    return(
        <React.Fragment>
            <BackButtonWrapper className="mr-4" onClick={handleBack}>
                <img src="/logos/Vector.svg" />
            </BackButtonWrapper>
        </React.Fragment>
    )
}

export default BackButton;